// The one place that asks the browser for its zone (Intl is environment, not
// data): the account keeps it so the daily email lands in the morning here
// and the times in it read local. Empty when the runtime cannot say.
export const getBrowserTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? ''
  } catch {
    return ''
  }
}
